import React from 'react';
import { constants } from './Constant';
import 'bootstrap/dist/css/bootstrap.min.css';
import '../assets/css/fontawesome.css';
import '../assets/css/root.css';
import '../assets/css/lightbox.css';

const Footer = () => {
  return (
    <section className="contact-us" id="contact">
      <div className="container">
        <div className="row">
          <div className="col-lg-9 align-self-center">
            <form id="contact" action="" method="post">
              <div className="row">
                <div className="col-lg-12">
                  <h2>{constants?.footerPage?.title1}</h2>
                </div>
                
                {/* Form fields here */}
                <div className="col-lg-4">
                  <fieldset>
                    <input name="name" type="text" id="name" placeholder="YOUR NAME..." required />
                  </fieldset>
                </div>
                <div className="col-lg-4">
                  <fieldset>
                    <input name="email" type="text" id="email" pattern="[^ @]*@[^ @]*" placeholder="YOUR EMAIL..." required />
                  </fieldset>
                </div>
                <div className="col-lg-4">
                  <fieldset>
                    <input name="subject" type="text" id="subject" placeholder="SUBJECT..." required />
                  </fieldset>
                </div>
                <div className="col-lg-12">
                  <fieldset>
                    <textarea name="message" className="form-control" id="message" placeholder="YOUR MESSAGE..." required></textarea>
                  </fieldset>
                </div>
                <div className="col-lg-12">
                  <fieldset>
                    <button type="submit" id="form-submit" className="button">{constants?.footerPage?.buttonName}</button>
                  </fieldset>
                </div>
              </div>
            </form>
          </div>
          <div className="col-lg-3">
            <div className="right-info">
              <ul>
                <li><h6>{constants?.footerPage?.phoneNumberLabel}</h6><span>{constants?.footerPage?.phoneNumber}</span></li>
                <li><h6>{constants?.footerPage?.emailAddressLabel}</h6><span>{constants?.footerPage?.emailAddress}</span></li>
                <li><h6>{constants?.footerPage?.AddressLine1}</h6><span>{constants?.footerPage?.AddressLine2}</span></li>
                <li><h6>{constants?.footerPage?.webSiteLabel}</h6><span>{constants?.footerPage?.webSite}</span></li>
              </ul>
            </div>
          </div>
        </div>
        <div className="footer">
          <div className="sub-header">
            <div className="container">
            <div className="row">
                <div className="col-lg-8 col-sm-8">
                    <div className="left-content">
            <p>{constants?.footerPage?.copyrightLabel1} <em>{constants?.footerPage?.copyrightLabel2} </em> {constants?.footerPage?.copyrightLabel3} </p>
           </div>
           </div>
           <div className="col-lg-4 col-sm-4">
           <div className="right-icons">

            <ul>
              <li><a href="#"><i className="fa fa-facebook"></i></a></li>
              <li><a href="#"><i className="fa fa-twitter"></i></a></li>
              <li><a href="#"><i className="fa fa-linkedin"></i></a></li>
            </ul>
          </div>
        </div>
        </div>
        </div>
        </div>
        </div>
      </div>
    </section>
  );
};

export default Footer;

